// The coins BFF router was decommissioned along with je-client. This hook is
// retained as an inert stub so obsolete coins UI still compiles; it no longer
// fetches transactions.
export type QueryOptions = {
  enabled?: boolean;
};

export type Params = {
  page?: number;
  perPage?: number;
};

export type SuccessResponse = {
  transactions: any[];
  total: number;
};
export type ErrorResponse = null;

export const useFetchTransactions = (
  _params: Params,
  _queryOptions?: QueryOptions
) => {
  return {
    data: undefined as SuccessResponse | undefined,
    isError: false,
    error: null as ErrorResponse,
    isLoading: false
  };
};
